import React from "react";
import { PeopleAlt, PlaylistAddCheck } from "@material-ui/icons";
import { useHistory } from "react-router";

function Segregation() {
  const history = useHistory();
  return (
    <div className="skills">
      <div
        className="skills__allSkills"
        onClick={() => history.push("/UserData", { approve: false })}
      >
        <PeopleAlt style={{ fontSize: 100 }} />
        <p style={{ margin: "20px 0", fontSize: 20 }}>All Users</p>
      </div>
      <div
        className="skills__approvals"
        onClick={() => history.push("UserData?", { approve: true })}
      >
        <PlaylistAddCheck style={{ fontSize: 100 }} />
        <p style={{ margin: "20px 0", fontSize: 20 }}>User Approvals Pending</p>
      </div>
    </div>
  );
}

export default Segregation;
